import { Link } from 'react-router-dom'
import { Megaphone, Mail } from 'lucide-react'

export function Advertise() {
  return (
    <div className="min-h-screen bg-black text-white">
      <section className="relative max-w-5xl mx-auto px-6 py-16">
        <div className="absolute inset-0 bg-gradient-to-b from-[#050309] via-black to-black -z-10" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_0,rgba(212,175,55,0.18),transparent_55%),radial-gradient(circle_at_100%_100%,rgba(74,31,184,0.35),transparent_55%)] -z-10" />

        <div className="flex items-center justify-between gap-4 mb-10">
          <Link to="/" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">
            &larr; Back to home
          </Link>
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-gray-400">
            <Megaphone className="w-4 h-4 text-[#D4AF37]" />
            For brands & advertisers
          </span>
        </div>

        <header className="mb-10">
          <p className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-3 py-1 text-xs font-medium text-[#FFD700] mb-4">
            <Megaphone className="w-4 h-4" />
            Reach African audiences
          </p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#D4AF37] via-[#FFFFFF] to-[#D4AF37] bg-clip-text text-transparent">
            Advertise on Binyuma TV
          </h1>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mb-4">
            Connect your brand with engaged viewers across Africa and the diaspora. Our vertical-first platform
            delivers premium inventory and measurable reach for campaigns that resonate.
          </p>
          <p className="text-sm text-gray-400 max-w-2xl">
            For media kits, rates, and partnership opportunities, get in touch with our team.
          </p>
        </header>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="mailto:ads@binyumatv.com"
            className="inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium bg-[#D72638] hover:bg-[#D72638]/90 text-white transition-colors w-fit"
          >
            <Mail className="w-4 h-4 mr-2" />
            Contact advertising team
          </a>
          <Link to="/" className="inline-flex items-center text-sm text-gray-400 hover:text-[#D4AF37] transition-colors w-fit">
            Return home
          </Link>
        </div>
      </section>
    </div>
  )
}
